/* ec-nav-fix.js. runtime patch for Gym Software nav button color switching */
(function () {
  'use strict';

  // Mirror the exact same logic as the Navbar component:
  // u = true when a [data-theme="light"] section has its top <= 80 && bottom >= 80
  // _ = u ? "rgba(4,23,44,0.8)" : "rgba(255,255,255,0.9)"
  var DARK_COLOR = 'rgba(4,23,44,0.8)';
  var LIGHT_COLOR = 'rgba(255,255,255,0.9)';
  var THRESHOLD = 80;

  function getNavbarColor() {
    var sections = document.querySelectorAll('[data-theme="light"]');
    for (var i = 0; i < sections.length; i++) {
      var rect = sections[i].getBoundingClientRect();
      if (rect.top <= THRESHOLD && rect.bottom >= THRESHOLD) {
        return DARK_COLOR;
      }
    }
    return LIGHT_COLOR;
  }

  function findGymBtn() {
    var buttons = document.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].textContent.trim() === 'Gym Software') {
        return buttons[i];
      }
    }
    return null;
  }

  function syncColor() {
    var gymBtn = findGymBtn();
    if (!gymBtn) return;
    gymBtn.style.color = getNavbarColor();
    gymBtn.style.setProperty('color', getNavbarColor(), 'important');
  }

  // Run on scroll (same as navbar)
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        syncColor();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Also run periodically to catch React re-renders resetting the color
  setInterval(syncColor, 200);

  // Run immediately after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncColor);
  } else {
    // Retry until the React app mounts the button
    var attempts = 0;
    var init = setInterval(function () {
      attempts++;
      syncColor();
      if (findGymBtn() || attempts > 50) {
        clearInterval(init);
      }
    }, 100);
  }

})();
